'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("itDefaultConfig", function () {
  // Unused, only for documentation
  var columnOptions = {
    // the unique ID for this column. if unset a default id will be generated
    id: 'myId',
    // the attribute associated with this column. It can be nested.
    // by default (unless `expression` or `template` is provided), this is what will be displayed in the cell
    // note that is is also used for
    attribute: 'some.attribute',
    // the type of the data to render. Currently only used for sorting and footer data aggregation features.
    dataType: 'number',
    // allow to use an angular filter when rendering in `attribute` mode.
    // has no effect for `expression` and `template` modes
    filter: 'montant:2',
    // takes precedence over attribute if present, used for more complex display
    expression: '{{$index + 1}} {{model.Attribute}}',
    // most advanced rendering option. Accepts a plain angular template that will be compiled
    template: "<div>{model.attribute}</div>",
    // if true, attribute and expression rendering mode will be using active watchers
    // instead of one-shot interpolation.
    // this has no effect when `template` is provided
    watch: false,
    // the title to be displayed on the header cell
    // can be either a string, or an array of string for multi-line titles
    title: 'My Column',
    // displays a tooltip when hovering over the header cell.
    // can either be a string or plain html (this will NOT be compiled)
    tooltip: 'Some tooltip',
    // if config.sortable OR column.sortable is true, the column will allow sorting
    sortable: true,
    // can be either a string identifying the type of the data for the sorting method,
    // or a function to use for sorting ( (a, b) => +-1 )
    // note that if not provided, 'dataType' will be used instead if present
    // see `itSortFactory`
    sortType: 'string',
    // custom class to append to the cell (TD) element. Mostly used for text-align.
    cellClass: 'align-r',
    // set to true to enabled footer data aggregation. `config.footer` must be set.
    // when enabled, it will use the default reducer for the specified `dataType` unless `footerReducer` is set.
    footer: false,
    // when set, will override the default data aggregator / reducer used for footer value computation
    // this can either be a string (id of the reducer in `itFooterAccumulator`), or a function of the form
    footerReducer: function footerReducer(data, attribute) {
      return _.reduce(data, function (sum, current) {
        return sum + _.get(current, attribute);
      }, 0);
    },
    // allow to specify specific css class for the footer cell. If unset, will defaults to `cellClass`
    footerCellClass: 'my-class',
    // allow to specify a specific filter for the footer cell rendering. if unset, will use `filter`
    // has no effect if `footerTemplate` is provided
    footerFilter: 'montant',
    // allow to specify a template for the footer cell rendering. you can also refere tu footerValues['col-anotherTotalColumn'] to get other columns values values
    footerTemplate: "<div>Somme: {{footerValue}}</div>",
    // if config.resizable is true, the column can be resized unless column.resizable is false
    resizable: true,
    // if config.reorderable is true, the column can be reordered unless column.reorderable is false
    reorderable: true
  };
  return {
    type: "table",
    // "table" / "tree"
    // row selection
    allowSelection: false,
    selectionAttribute: null,
    // attribute to set / get selected model from / to.
    selectionScope: null,
    // the scope to get / set selection attribute from/to . Defaulting to the table parent scope.
    // sorting
    sortable: false,
    // config.sortable || column.sortable
    initialSort: null,
    // initial sorting column and order. either the index of the column or a tuple [columnIdx, "desc" | "asc"]
    keepIndexOnSort: false,
    // do we stay at current index after sorting or do we go back to index 0 ?
    persistSort: true,
    // if true and table has a specified id, will pe
    // global events
    onScrollChange: null,
    // handler called when table render change (scroll, resize, dataSource change...) called with pagination as first parameter and ordered dataSource as second
    keepIndexOnReload: false,
    initialScroll: 0,
    // can be either a model, an index or a function given dataSource as only parameter and returning a model or an index.
    // row events
    hoverClass: null,
    onRowClick: null,
    onRowEnter: null,
    onRowLeave: null,
    eventApplyScope: null,
    // scope used for the apply of delegated event handler. Defaulting to the table scope.
    // Row management - cleanup & precompilation
    maxWatchers: 600,
    // maximum number of watcher, after what the table will start to cleanup undisplayed rows.
    countRootWatchers: false,
    // if true, will count the rootScope's watchers instead of the table's.
    rowManagementCycleInterval: 200,
    // interval between cleanup / precompilation cycles
    preloadedPageCount: 1,
    // number of pages before/after current displayed data to preload
    rowPerManagementCycle: 3,
    // max number of row to compile/destroy per cycle
    // general config
    watch: false,
    // if set to true, the column definition using attribute (and optionally filter) will watch for changes. Else the value expression will only be interpolated once, at row creation
    height: 500,
    // default height for the table is no sizing directive is used
    columnGroups: [],
    // columns group for column toggle features.
    // scrollbar config
    scrollbarWidth: 12,
    // width of the scrollbar. can be overridden for theming
    scrollbarThumbMinHeight: 20,
    // min height of the scrollbar thumb
    scrollbarThumbMaxHeight: null,
    // max height of the scrollbar thumb
    // templates
    headerGroupRowTemplate: '<tr class="it-group-row"></tr>',
    headerGroupCellTemplate: '<th class="it-group-cell"></th>',
    headerRowTemplate: '<tr class="it-header-row"></tr>',
    headerCellTemplate: '<th class="it-header-cell"></th>',
    contentHeaderCellTemplate: '<th class="body-header"></th>',
    rowTemplate: '<tr></tr>',
    cellTemplate: '<td></td>',
    footerRowTemplate: '<tr class="it-footer-row"></tr>',
    footerCellTemplate: '<td class="it-footer-cell"></td>',
    // directives
    headerCellDirective: "it-header-cell",
    headerGroupCellDirective: "it-header-group-cell",
    rowDirective: "it-row",
    footerRowDirective: 'it-footer-row',
    footerCellDirective: 'it-footer-cell',
    // footer
    footer: false,
    // either 'static' (fixed at the bottom), 'inline' (with data rows), or false (disabled)
    // visibility management
    visibilityManager: null,
    // to handle visibility management. must be an object implementing isVisible() and onVisibilityChange()
    // state management
    stateManager: null,
    // to manage persisted state of the table. see infiniTableConfigManager

    subtotalRowTemplate: '<tr class="it-subtotal-row"></tr>',
    subtotalCellTemplate: '<td class="it-subtotal-cell"></td>',
    subtotalRowDirective: 'it-subtotal-row',
    subtotalCellDirective: 'it-subtotal-cell'
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/infiniTable/standard/itDefaultConfig.js
// module id = 2811
// module chunks = 13